import { createAsyncThunk } from "@reduxjs/toolkit";
import { announcementQueryService } from "../../../../../utils/services/query/Announcement/announcementService";

export const fetchAnnouncementQuery = createAsyncThunk(
  "Announcement/fetch",
  async (_, thunkAPI) => {
    const { page, limit, searchKey } = thunkAPI.getState().announcement;

    const payload = {
      pageNo: page + 1,
      pageLength: limit,
      name: searchKey,
    };

    try {
      const response = await announcementQueryService(payload);
      console.log("response inside the announcement", response);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
